import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import descend from 'ramda/src/descend';
import isEmpty from 'ramda/src/isEmpty';
import prop from 'ramda/src/prop';
import slice from 'ramda/src/slice';
import sort from 'ramda/src/sort';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Icon from '@components/@core/Icon';
import Rating from '@components/@core/Rating';
import CompanyActions from '~/actions/company';
import VendorActions from '~/actions/vendor';
import withNavigate from '~/hocs/withNavigate';

class ByCategory extends Component {
    state = { hovered: null };
    topRef = createRef();

    componentDidMount() {
        this.props.getCategories();
        this.props.getAllPopularProducts();

        if (this.topRef.current) {
            this.topRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    handleMouseEnter = (item) => (event) => {
        event.preventDefault();
        this.setState({ hovered: item });
    };

    handleMouseLeave = (event) => {
        event.preventDefault();
        this.setState({ hovered: null });
    };

    handleOpenDetail = (item) => (event) => {
        event.preventDefault();
        this.props.getDetail({
            categoryId: item.id,
            payload: { per_page: 25 },
            route: `/vendor-ratings/by-category/${item.id}`,
        });
    };

    handleOpenProduct = (product) => () => {
        const { category, parent } = product;
        if (parent.business_id) {
            const payload = { id: parent.business_id };
            const route = {
                pathname: `/business/${product.slug}`,
                search: `?id=${parent.business_id}&category=${category.id}`,
            };
            this.props.getBusiness(payload, route);
            this.props.getPopular(category.id);
        } else {
            toast.error('This product does not have business yet. Please reach out to Brandon!', {
                position: toast.POSITION.TOP_RIGHT,
                pauseOnFocusLoss: false,
                hideProgressBar: true,
            });
        }
    };

    render() {
        const { hovered } = this.state;
        const { categories } = this.props;
        const { all, popular } = categories;

        const populars = slice(0, 9, sort(descend(prop('product_total')), popular));

        return (
            <ErrorBoundary className="vendor-rating-category">
                <Helmet>
                    <title>Dealership Vendor Ratings by name | DrivingSales</title>
                    <meta name="description" content="Dealership Vendor Ratings by name | DrivingSales" />
                </Helmet>
                <div className="d-h-start vendor-sm mb-3 mt-2" ref={this.topRef}>
                    <Button className="btn-vendor-ratings" type="link" name="Vendor Ratings" onClick={() => this.props.navigate('/vendor-ratings')} />
                    <p className="dsl-m14 mb-0">
                        <Icon name="fas fa-chevron-right mx-2" size={12} color="#969faa" />
                        By Category
                    </p>
                </div>
                {/* Temporarity hide according to 8103 */}
                {/* <div className="popular-category">
          <p className="dsl-b20 bold">Popular Categories</p>
          <Row className="m-0 p-2">
            {populars.map(item => (
              <Col
                xs={12}
                sm={6}
                lg={4}
                key={item.id}
                className="popular-category-item"
                onClick={this.handleOpenDetail(item)}
              >
                <p className="dsl-b15 mb-0 py-2 pe-1">{item.name}</p>
                <p className="dsl-d14 mb-0 py-2">({item?.product_total || 0})</p>
              </Col>
            ))}
          </Row>
        </div> */}
                <Row className="m-0" onMouseLeave={this.handleMouseLeave}>
                    <Col xs={12} md={8} className="p-0">
                        <div className="all-category cursor-pointer me-2">
                            <div className="d-h-between px-4">
                                <p className="dsl-b20 bold">All Categories</p>
                                {/*<Search />*/}
                            </div>
                            <Row className="d-h-end border-bottom py-2 px-2 mx-2 my-0">
                                <Col xs={6} />
                                <Col xs={3} className="p-0">
                                    <p className="dsl-b14 text-end m-0">Products</p>
                                </Col>
                                <Col xs={3} className="p-0">
                                    <p className="dsl-b14 text-end m-0 ps-3">Verified Ratings</p>
                                </Col>
                            </Row>
                            <div className="all-category-list">
                                {all.map((category) => {
                                    const isHover = hovered ? category.id === hovered.id : false;
                                    return (
                                        <Row
                                            key={category.id}
                                            className={`category-item ${isHover ? 'hovered' : ''} py-4 px-2 mx-2`}
                                            onMouseEnter={this.handleMouseEnter(category)}
                                            onClick={this.handleOpenDetail(category)}
                                        >
                                            <Col xs={6} className="p-0">
                                                <p className="dsl-p16 m-0">{category.name}</p>
                                            </Col>
                                            <Col xs={3} className="p-0">
                                                <p className="dsl-b16 text-end m-0">{category?.product_total || 0}</p>
                                            </Col>
                                            <Col xs={3} className="p-0">
                                                <p className="dsl-b16 text-end m-0">{Math.ceil(Number(category.total_verified_ratings || 0))}</p>
                                            </Col>
                                        </Row>
                                    );
                                })}
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={4} className="p-0">
                        {hovered ? (
                            <div className="preview-category mb-2">
                                <div className="preview-info">
                                    <p className="dsl-b18 bold">Featured</p>
                                    {hovered?.popular &&
                                        hovered.popular.map((item, index) => (
                                            <Row key={`${item.id}-${index}`} className="mx-0 py-3 cursor-pointer" onClick={this.handleOpenProduct(item)}>
                                                <Col xs={5} className="pl-0">
                                                    <Avatar
                                                        size="medium"
                                                        url={item.logo}
                                                        name={item.name}
                                                        isSponsored={item.data.sponsored_level === 'gold' || item.data.sponsored_level === 'silver'}
                                                        type="logo"
                                                    />
                                                </Col>
                                                <Col xs={7} className="pl-0">
                                                    <p className="dsl-b16 mb-0">{item.name}</p>
                                                    <Rating score={Math.round(item?.stats?.rating_avg * 10) / 10} />
                                                </Col>
                                            </Row>
                                        ))}
                                </div>
                            </div>
                        ) : (
                            <div className="preview-category">
                                <div className="preview-info d-h-center">
                                    <p className="dsl-b14 text-center">Find the variety you are looking for and explore over 97,000 verified reviews from your dealer peers!</p>
                                </div>
                            </div>
                        )}
                    </Col>
                </Row>
            </ErrorBoundary>
        );
    }
}

ByCategory.propTypes = {
    categories: PropTypes.shape({
        all: PropTypes.array,
        popular: PropTypes.array,
    }),
    getBusiness: PropTypes.func,
    getCategories: PropTypes.func,
    getDetail: PropTypes.func,
    getPopular: PropTypes.func,
    getAllPopularProducts: PropTypes.func,
};

ByCategory.defaultProps = {
    categories: {
        all: [],
        popular: [],
    },
    getBusiness: () => {},
    getCategories: () => {},
    getDetail: () => {},
    getPopular: () => {},
    getAllPopularProducts: () => {},
};

const mapStateToProps = (state) => ({
    authenticated: !isEmpty(state.app.token),
    userId: state.app.id,
    categories: state.vendor.categories,
});

const mapDispatchToProps = (dispatch) => ({
    getBusiness: (payload, route) => dispatch(CompanyActions.getbusinessRequest(payload, route)),
    getCategories: () => dispatch(VendorActions.getcategoriesRequest()),
    getDetail: (e) => dispatch(VendorActions.getcategoryproductsRequest(e)),
    getPopular: (e) => dispatch(VendorActions.getcategorypopularproductsRequest(e)),
    getAllPopularProducts: () => dispatch(VendorActions.getallcategorypopularproductsRequest()),
});

const ByCategoryWithNavigate = withNavigate(ByCategory);

export default connect(mapStateToProps, mapDispatchToProps)(ByCategoryWithNavigate);
